import { useFormContext, useWatch } from 'react-hook-form'
import { useState } from 'react'

import { Card, CardContent } from '@/components/ui/card'
import { ProductModel } from '@/types/model/Product'

import { VariantCardHeader } from './variant-card/VariantCardHeader'
import { VariantFormFields } from './variant-card/VariantFormFields'
import { VariantAttributesSelector } from './variant-card/VariantAttributesSelector'
import { VariantMediaGallery } from './variant-card/VariantMediaGallery'

interface VariantCardProps {
  index: number
  onRemove: (index: number) => void
  attributeValueNames: string
  attributes: ProductModel.IAttribute[]
}

export const VariantCard = ({ index, onRemove, attributeValueNames, attributes }: VariantCardProps) => {
  const [isOpen, setIsOpen] = useState(true)
  const { control, watch } = useFormContext<ProductModel.ProductFormData>()

  const images = useWatch({ control, name: `variations.${index}.images` })
  const attributeValueIds = useWatch({ control, name: `variations.${index}.attribute_value_ids` }) || []
  const selectedAttributeIds = watch('attributes') || []
  const relevantAttributes = attributes.filter((attr) => selectedAttributeIds.includes(attr._id))

  const dynamicAttributeName = attributeValueIds
    .map((id: string) => {
      for (const attr of attributes) {
        const val = attr.values.find((v) => v._id === id)
        if (val) return val.name
      }
      return null
    })
    .filter(Boolean)
    .join(' / ')

  const thumbnailUrl = images?.[0]?.url

  return (
    <Card className="overflow-hidden shadow-none">
      <VariantCardHeader
        index={index}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onRemove={onRemove}
        displayName={dynamicAttributeName || attributeValueNames}
        thumbnailUrl={thumbnailUrl}
      />
      {isOpen && (
        <CardContent className="space-y-4 border-t border-border-subtle p-4">
          <VariantFormFields index={index} />
          <VariantAttributesSelector index={index} relevantAttributes={relevantAttributes} />
          <VariantMediaGallery index={index} />
        </CardContent>
      )}
    </Card>
  )
}
